<script setup lang="ts">
import { BRAND, footerColumns, socialLinks } from '../data/landing.content'
import { useLandingScroll } from '../composables/useLandingScroll'

const { registerReveal, smoothScrollTo } = useLandingScroll()

function onLinkClick(href: string) {
  if (href.startsWith('#')) {
    smoothScrollTo(href)
    return
  }
  window.location.assign(href)
}
</script>

<template>
  <footer class="wl-footer">
    <div class="container">
      <div class="wl-footer-top">
        <div class="wl-footer-brand">
          <a href="#inicio" class="wl-nav-logo" @click.prevent="smoothScrollTo('#inicio')">
            <div class="wl-logo-icon" aria-hidden="true">
              <img src="/images/appmisionate-icon.svg" alt="">
            </div>
            <span><span class="wl-logo-app">App</span>misiónate</span>
          </a>
          <p>
            La plataforma digital de simuladores para el EXANI y los exámenes EGEL de CENEVAL. Más de 5,000 estudiantes
            aprobados.
          </p>
          <div class="wl-footer-social">
            <a
              v-for="social in socialLinks"
              :key="social.label"
              :href="social.href"
              target="_blank"
              rel="noopener"
              :aria-label="social.label"
              class="wl-social-btn"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                :fill="social.filled ? 'currentColor' : 'none'"
                stroke="currentColor"
                stroke-width="2"
              >
                <path v-for="(path, i) in social.icon.split('|')" :key="i" :d="path" />
              </svg>
            </a>
          </div>
        </div>

        <div class="wl-footer-nav">
          <div v-for="column in footerColumns" :key="column.title" class="wl-footer-col">
            <h4>{{ column.title }}</h4>
            <ul>
              <li v-for="link in column.links" :key="link.label">
                <a :href="link.href" @click.prevent="onLinkClick(link.href)">{{ link.label }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="wl-footer-bottom">
        <p>{{ BRAND.copyright }}</p>
        <p>Diseñado para estudiantes que quieren llegar lejos.</p>
      </div>
    </div>
  </footer>
</template>
